import { Injectable } from '@angular/core';
import { Http, Headers, Response, URLSearchParams, RequestOptions, ResponseContentType } from '@angular/http';
import { CommonService } from './common.service';
import { ErrorService } from './error.service';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { TransferHistory } from './../models/transferhistory';

@Injectable({
  providedIn: 'root'
})
export class TransferHistoryService {
  private url = CommonService.getEwdApiURL() + 'TransferHistory';

  constructor(
    private http: Http,
    private errorService: ErrorService
    ) { }

  getTransferHistories(driverId: number, dateStart: any, dateEnd: any): Observable<TransferHistory[]> {
    return this.http.post(this.url + '/TransferHistoryByDate?', {
      DriverId: driverId,
      StartUTCDate: dateStart,
      EndUTCDate: dateEnd
    }).map(
      (response: Response) => response.json()
      )
      .catch(this.errorService.handleError);
  }

  downloadFile(fileName): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();
    params.set('fileName', fileName);
    const queryString = params.toString();
    return this.http.get(this.url + '/DownloadFile?' + queryString, {responseType: ResponseContentType.Blob}).map(
      (response: Response) => response.blob()
      )
      .catch(this.errorService.handleError);
  }

  transfer(ewdRecords, startDate, endDate, driverId, emails, subject, body, requestBy ) {
    return this.http.post(this.url + '/TransferList',
      {
        StartDateTime: startDate,
        EndDateTime: endDate,
        EWDRecords: ewdRecords,
        DriverId: driverId,
        Username: '',
        RecipientEmailAddresses: emails,
        EmailSubject: subject,
        EmailContent: body,
        ChangedByUsername: requestBy
      })
    .map(
      (response: Response) => response.json
      )
      .catch(this.errorService.handleError);
  }
}
